import { NestedEntity } from 'types';

export const getName = (entity: NestedEntity) => entity.data.attributes.name;
